import { useNextActions } from "../lib/proactive";
import "../styles.proactive.css";

/**
 * KI-Tagesimpuls "Fokus heute" (BEN-106, W2.3) - aus den naechsten Schritten verdichtet.
 * Grounded: die KI verdichtet nur die echten Punkte, erfindet nichts. Faellt sauber
 * auf einen regelbasierten Einzeiler zurueck, wenn das lokale Modell nicht antwortet.
 */
export default function FokusHeute({ role }: { role: "berater" | "kunde" }) {
  const q = useNextActions(role, { limit: 5, focus: true, });
  const data = q.data;
  const engineLocal = (data?.focus_engine ?? "").startsWith("local");

  return (
    <div className="fh-card" role="note" aria-label="KI-Tagesimpuls">
      <div className="fh-ic" aria-hidden>&#10035;</div>
      <div className="fh-body">
        <div className="fh-k">
          <strong>KI-Fokus heute</strong>
          <span className="fh-engine muted small" title={engineLocal ? "vom lokalen Modell formuliert" : "regelbasiert formuliert"}>
            {engineLocal ? "lokales Modell" : "regelbasiert"}
          </span>
        </div>
        {q.isLoading ? (
          <p className="fh-text muted">Die KI fasst Ihre wichtigsten Punkte zusammen &hellip;</p>
        ) : q.isError ? (
          <p className="fh-text muted">Tagesimpuls gerade nicht verfuegbar &mdash; die naechsten Schritte unten bleiben nutzbar.</p>
        ) : (
          <p className="fh-text">{data?.focus_today}</p>
        )}
      </div>
    </div>
  );
}
